import checkout from './checkout/zh.js'
import components from './components/zh.js'
import menu from './menu/zh.js'
import map from './map/zh.js'
import merchant from './merchant/zh.js'
import merchantAccount from './merchantAccount/zh.js'
import system from './system/zh.js'
import customerService from './customerService/zh.js'
import dashboard from './dashboard/zh.js'
import data from './data/zh.js'
import payment_links from './payment_links/zh.js'
import merchant_auth from './merchant_auth/zh.js'
import send_pagements from './send_pagements/zh.js'
import developer from './developer/zh.js'
import payment_page from './payment_page/zh.js'
import createMchCode from './createMchCode/zh.js'
import va from './va/zh.js'
import tips from './tips/zh.js'
import serviceProvider from './serviceProvider/zh.js'
import paymentLink from './payment_links/zh.js'
import kyc from './kyc/zh.js'
import acceptPayments from './acceptPayments/zh.js'
import no_auth from './no_auth/zh.js'
import operation from './operation/zh.js'

export default {
  components,
  menu,
  map,
  merchant,
  merchantAccount,
  system,
  customerService,
  dashboard,
  data,
  payment_links,
  merchant_auth,
  send_pagements,
  developer,
  payment_page,
  createMchCode,
  va,
  tips,
  checkout,
  serviceProvider,
  paymentLink,
  kyc,
  acceptPayments,
  no_auth,
  operation,
  mfa: {
    timeout_title: '安全超时校验',
    timeout_content: '输入谷歌MFA验证码',
    title: '安全验证',
    code: 'MFA验证码',
    placeholder: '请输入MFA验证码',
    required: '请输入MFA验证码',
    length: '请输入6位验证码',
    invalid: 'MFA验证码无效',
    enter_code: '请输入Google Authenticator提供的6位MFA验证码'
  }
}
